<template>
    <div class="company-banner-container">
        <div class="company-banner-content">
            <h1>企业服务中心</h1>
            <p class="company-banner-des">
                中小企业一站式采购平台，工商记账、营销推广、软件采购、业务上云，就来企业服务中心
            </p>
            <ul class="company-banner-advantage">
                <li v-for="(item, index) in advantage" :key="index">
                    <img :src="item.img" />
                    <span>{{ item.text }}</span>
                </li>
            </ul>
            <a class="more-company-service"
                target="_blank"
                href="https://qifu.baidu.com"
                data-track-value="landMoreService"
                data-track-name="更多企业服务"
                >更多企业服务</a>
        </div>
    </div>
</template>

<script>
import dainzan from '../assets/dianzan.png';
import wangguan from '../assets/wangguan.png';
import fuwu from '../assets/fuwu.png';
export default {
    data() {
        return {
            advantage: [
                {
                img: dainzan,
                text: '精选优质企业服务',
                },
                {
                img: wangguan,
                text: '高性价比专属特惠',
                },
                {
                img: fuwu,
                text: '专家服务 实时响应',
                },
            ]
        };
    }
};
</script>

<style lang="less" scoped>
.company-banner-container {
    width: 100%;
    height: 196px;
    background: url(../assets/company_banner.png) no-repeat;
    background-size: 100% 100%;
    .company-banner-content {
        width: 1200px;
        margin: 0 auto;
        padding-top: 32px;
        position: relative;
        h1 {
            height: 33px;
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 500;
            line-height: 33px;
            color: #fff;
            margin-bottom: 10px;
        }
        .company-banner-des {
            height: 22px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 22px;
            color: #fff;
            margin-bottom: 32px;
        }
        li {
            list-style-type: none;
        }
        .company-banner-advantage {
            display: flex;
            align-items: center;
            padding: 0;
        li {
            margin-right: 125px;
        }
        img {
            width: 35px;
            height: 35px;
            vertical-align: middle;
            margin-right: 10px;
        }
        span {
            display: inline-block;
            height: 35px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 35px;
            color: #fff;
        }
        }
        .more-company-service {
            position: absolute;
            top: 81px;
            right: 0;
            height: 34px;
            border: 1px solid #fff;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 32px;
            color: #fff;
            padding: 0 26px;
            text-decoration: none;
            background-color: transparent;
        }
        .more-company-service:hover {
            background-color: #fff;
            color: #2468F2;
        }
    }
}
</style>
